import { getBalance } from './GetBalance';
import { getWallet } from './GetWallet';

export const balanceServices = {
  getBalance,
  getWallet,
};
